<section
  class="image-uploader"
  [class.image-uploader--dragging]="isDragging"
  [class.image-uploader--disabled]="disabled"
>
  @if (showHeader) {
    <div class="image-uploader__header">
      <div>
        <h3>{{ title }}</h3>
        <p>{{ subtitle }}</p>
      </div>

      <button
        type="button"
        mat-stroked-button
        class="image-uploader__add-button"
        (click)="openFilePicker()"
        [disabled]="disabled"
      >
        <span class="image-uploader__button-content">
          <i-tabler
            name="circle-plus"
            class="image-uploader__button-icon"
          ></i-tabler>
          <span>Adicionar</span>
        </span>
      </button>
    </div>
  }

  <input
    #fileInput
    type="file"
    accept="image/*"
    multiple
    hidden
    (change)="handleFileInputChange($event)"
  />

  <div
    class="image-uploader__stage"
    role="button"
    tabindex="0"
    (click)="openFilePicker()"
    (keydown)="handleStageKeydown($event)"
    (dragenter)="handleDragEnter($event)"
    (dragover)="handleDragOver($event)"
    (dragleave)="handleDragLeave($event)"
    (drop)="handleDrop($event)"
  >
    @if (selectedImage) {
      <img
        [src]="selectedImage.url"
        [alt]="selectedImage.name"
        class="image-uploader__preview"
      />

      <div class="image-uploader__overlay">
        <div>
          <strong>{{ selectedImage.name }}</strong>
          <span>
            {{ activeIndex + 1 }} de {{ images.length }} imagem{{
              images.length > 1 ? 'ns' : ''
            }}
            - {{ formatFileSize(selectedImage.size) }}
          </span>
        </div>
      </div>

      @if (images.length > 1) {
        <button
          type="button"
          class="image-uploader__nav image-uploader__nav--previous"
          [disabled]="!hasPreviousImage"
          (click)="goToPrevious($event)"
          aria-label="Imagem anterior"
        >
          <i-tabler
            name="chevron-left"
            class="image-uploader__nav-icon"
          ></i-tabler>
        </button>

        <button
          type="button"
          class="image-uploader__nav image-uploader__nav--next"
          [disabled]="!hasNextImage"
          (click)="goToNext($event)"
          aria-label="Proxima imagem"
        >
          <i-tabler
            name="chevron-right"
            class="image-uploader__nav-icon"
          ></i-tabler>
        </button>
      }
    } @else {
      <div class="image-uploader__empty">
        <span class="image-uploader__empty-icon">
          <i-tabler name="photo-plus"></i-tabler>
        </span>
        <strong>{{ isDragging ? 'Solte as imagens aqui' : emptyTitle }}</strong>
        <p>{{ emptyDescription }}</p>
        <span>PNG, JPG ou WEBP ate {{ maxFileSizeMb }} MB</span>
      </div>
    }

    @if (isDragging) {
      <div class="image-uploader__drop-hint">Solte para adicionar</div>
    }
  </div>

  <mat-form-field
    appearance="outline"
    color="primary"
    class="image-uploader__description no-subscript"
  >
    <input
      matInput
      type="text"
      [disabled]="!selectedImage || disabled"
      [placeholder]="descriptionPlaceholder"
      [ngModel]="selectedImage?.description ?? ''"
      (ngModelChange)="updateDescription($event)"
    />
  </mat-form-field>

  <div class="image-uploader__footer">
    <span>{{ imageCountLabel }}</span>

    <div class="image-uploader__actions">
      <button
        type="button"
        mat-stroked-button
        class="image-uploader__add-button"
        (click)="openFilePicker()"
        [disabled]="disabled || images.length >= maxFiles"
      >
        <span class="image-uploader__button-content">
          <i-tabler
            name="circle-plus"
            class="image-uploader__button-icon"
          ></i-tabler>
          <span>Adicionar</span>
        </span>
      </button>

      @if (selectedImage) {
        <button
          type="button"
          mat-button
          color="warn"
          class="image-uploader__remove-button"
          (click)="removeSelectedImage($event)"
          [disabled]="disabled"
        >
          <span class="image-uploader__button-content">
            <i-tabler
              name="trash"
              class="image-uploader__button-icon"
            ></i-tabler>
            <span>Remover</span>
          </span>
        </button>
      }
    </div>
  </div>

  @if (feedbackMessage) {
    <div class="image-uploader__feedback" role="alert">
      {{ feedbackMessage }}
    </div>
  }

  @if (images.length > 1) {
    <div class="image-uploader__thumbs" aria-label="Imagens selecionadas">
      @for (image of images; track image.id) {
        <button
          type="button"
          class="image-uploader__thumb"
          [class.image-uploader__thumb--active]="image.id === selectedImage?.id"
          (click)="selectImage(image.id)"
          [attr.aria-label]="'Selecionar ' + image.name"
        >
          <img [src]="image.url" [alt]="image.name" />
        </button>
      }
    </div>
  }
</section>
